module.exports = __webpack_public_path__ + "static/media/02.c67d0529.png";